import imageCompression from 'browser-image-compression';

export type ImageClientCompression = 'default' | 'none';

export class FilesHelper {
	public readonly imageExtensions: string[] = ['png', 'jpg', 'jpeg', 'gif', 'ico', 'svg', 'webp'];
	public readonly maxImageWidthOrWeightForCompression: number = 1440;

	isImageFile(filename: string): boolean {
		for (const imageExtension of this.imageExtensions) {
			if (filename.toLowerCase().endsWith(imageExtension.toLowerCase())) {
				return true;
			}
		}

		return false;
	}

	isImageExtension(extension: string): boolean {
		for (const imageExtension of this.imageExtensions) {
			if (imageExtension.toLowerCase() === extension.toLowerCase()) {
				return true;
			}
		}

		return false;
	}

	async compressFilesAsync(files: File[], compression: ImageClientCompression): Promise<File[]> {
		const compressedFiles: File[] = [];

		if (compression === 'none') {
			return files;
		}

		for (const file of files) {
			if (filesHelper.isImageFile(file.name)) {
				// only compress image files
				const compressedFile = await imageCompression(file, {
					useWebWorker: true,
					maxWidthOrHeight: filesHelper.maxImageWidthOrWeightForCompression,
					maxIteration: 10
				});

				compressedFiles.push(compressedFile);
			} else {
				compressedFiles.push(file);
			}
		}

		return compressedFiles;
	}
}

export const filesHelper = new FilesHelper();
